var scope_0 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/02ac69eca245bd3ea097b3ff8b2cd7fa.js').default;
var scope_1 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1cea2614f7dbfc18224c2d8689e477ca.js').default;
var scope_2 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1df8e7edf5464c2c6295971b558c8d3b.js').default;
var scope_3 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2b70003b459b0c9bbb46a2fd8a258083.js').default;
var scope_4 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2be009b100d55fcbb0b0ce73e4ddde28.js').default;
var scope_5 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/30ddbb023c07eae4d34f2486f1404442.js').default;
var scope_6 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3489a89481eeac1460345741807008c4.js').default;
var scope_7 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/36cbb606dcd07cd4ce9f396298d2ae4c.js').default;
var scope_8 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5cc610aa6ad9c412a3714c23d9037716.js').default;
var scope_9 = require('/Users/dle/Web/CurrencyDocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f6a7ee0b5a0af98439409670f329a98d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9 )
    